import request from 'Request'

const MessageTemplateService = {
  async get({ tCode }) {
    return request.get('/message-templates/list', { params: { t_code: tCode } })
  }
}

export default MessageTemplateService
